var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3909 13.9258L13.0781 9.44531H8.7793V6.53906C8.7793 5.31299 9.37871 4.11719 11.3041 4.11719H13.2598V0.302734C13.2598 0.302734 11.4857 0 9.79043 0C6.24844 0 3.93555 2.14639 3.93555 6.03047V9.44531H0V13.9258H3.93555V24.7576C4.72568 24.8817 5.53398 24.9453 6.35742 24.9453C7.18086 24.9453 7.98916 24.8817 8.7793 24.7576V13.9258H12.3909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.41b0658b292c9d1659322c7e93da5138.svg";
export { ForwardRef as ReactComponent };